
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { cloneDeep, pull, remove } from "lodash";
import CustomsPackingInfoInTable from "@/views/components/CustomsPackingInfoInTable.vue";
import {
  CustomsPackingModel,
  PackingVolume,
} from "@/model/HenganLoadingPlanModels";
import { LoadingPlanType } from "@/views/sales-management/SalesBookingOrderManagement.vue";

/*配置柜型*/
@Component({
  name: "ConfigContainerTypeComponent",
  components: { CustomsPackingInfoInTable },
  methods: {
    pull,
    remove,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private data: ContainerLoadingInfoData;
  @Prop({ required: false, default: true }) private editable: boolean;
  @Prop({ required: false, default: true }) private showLoadingPlans: boolean;
  @Prop({ required: false, default: false })
  private checkShippingOrder: boolean;
  @Prop({ required: false, default: "" }) private title: string;
  private data_: ContainerLoadingInfoData = new ContainerLoadingInfoData();

  @Watch("data", { deep: true, immediate: true })
  private convertData() {
    this.data_ = cloneDeep(this.data);
  }

  private calculateVolume(packingVolume: PackingVolume) {
    return new PackingVolume(
      packingVolume.length,
      packingVolume.width,
      packingVolume.height
    ).calculateVolume();
  }

  private calculateTotalAmount(
    customsPackingSet: CustomsPackingModel[]
  ): string {
    return customsPackingSet
      .map((c) => c.secondaryPackingSet)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map((s) => s.packingInfos)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map((info) => info.productInfos)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map((p) => p.totalNumberPcs * p.unitPrice)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
  }
}

export class ContainerLoadingInfoData {
  id: string;
  containerId: string;
  billOfLadingCode?: string; // 海运提单号
  containerTypeCode: string; // 柜型
  containerNumber: string; // 集装箱号
  sealNumber: string; // 铅封号
  logisticsCompany: string; // 物流公司
  licensePlateNumber: string; // 车牌号
  driverTel: string; // 司机号码
  weight: string; // 集装箱重量
  remark: string; // 装柜信息
  category: string;
  type: LoadingPlanType;
  palletQuantity: number;
  cartonsQuantity: number;
  totalProductQuantity: number;
  totalVolume: string;
  containerTypeRemark: string;
  loadingPlans: LoadingPlanInfo[] = [];
}

export class LoadingPlanInfo {
  id: string;
  type: LoadingPlanType;
  code: string;
  customsPackingInfos: CustomsPackingModel[] = [];
}
